'use client';

import { getLanguageFromLocale } from '@bomdisoft/translations';
import { HeroOrderCard } from '@pieleaf/app/[lang]/home/sections/hero/order-card';
import s from '@pieleaf/app/[lang]/home/sections/hero/styles.module.css';
import { heroClaimDeliveryBody, heroClaimDeliveryTitle, heroClaimDirectBody, heroClaimDirectTitle, heroClaimPayBody, heroClaimPayTitle, heroHeadline, heroSubhead, orderProduceText } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export const HeroSection = () => {
  const params = useParams();
  const lang = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(lang);

  const claims = [
    { body: heroClaimDirectBody, testId: 'hero-claim-direct', title: heroClaimDirectTitle },
    { body: heroClaimPayBody, testId: 'hero-claim-pay', title: heroClaimPayTitle },
    { body: heroClaimDeliveryBody, testId: 'hero-claim-delivery', title: heroClaimDeliveryTitle },
  ];

  return (
    <section className={s.section} data-testid='hero-section'>
      {/* The hero photograph is a CSS background, so the preload scanner cannot
       * see it and the largest paint waited on the stylesheet first. Preloading
       * it explicitly is what a `priority` <Image> would do, without giving up
       * the background-size: cover crop the layout depends on. */}
      <link fetchPriority='high' href='/images/produce/plantain-bunches.jpg' rel='preload' type='image/jpeg' {...{ as: 'image' }} />
      <div className={s.photo}>
        <div className={s.overlay} />
        <div className={s.caption}>
          <h1 className={s.title} data-testid='hero-headline'>
            {heroHeadline[language]}
          </h1>
          <p className={s.subhead}>{heroSubhead[language]}</p>
          {/* The header's Order produce button is hidden below 600px, so on a
           * phone this is the only route to the storefront. Same destination. */}
          <div className={s.ctaRow}>
            <a className={s.primaryCta} data-prodantix='Place an order' data-prodantix-action='place_order' data-testid='hero-primary-cta' href={`/${lang}/orders`}>
              {orderProduceText[language]}
            </a>
          </div>
        </div>
      </div>

      <HeroOrderCard />

      <div className={s.claims} data-testid='hero-claims'>
        {claims.map(claim => (
          <div className={s.claim} data-testid={claim.testId} key={claim.testId}>
            <p className={s.claimTitle}>{claim.title[language]}</p>
            <p className={s.claimBody}>{claim.body[language]}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
